import { Alert, Button, Space, Table, Tag, Typography } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import dayjs from 'dayjs'
import { useCallback, useState } from 'react'

import { useRemoteData } from '~/features/performance/useRemoteData'
import { getTeacherSchedule } from '~/services/teacher-schedule'

interface Schedule {
  id: string
  teacherId: string
  from: number
  to: number
  enabled: boolean
  taken: boolean
}

export default function TeacherScheduleList() {
  const [pagination, setPagination] = useState({ page: 1, size: 20 })
  const request = useCallback(async () => {
    const response = await getTeacherSchedule(pagination.page, pagination.size)
    return response.data as { content: Schedule[]; total: number }
  }, [pagination])
  const { data, loading, error, retry } = useRemoteData(request)
  const columns: ColumnsType<Schedule> = [
    { title: '排班 ID', dataIndex: 'id' },
    { title: '老师 ID', dataIndex: 'teacherId' },
    {
      title: '开始时间',
      dataIndex: 'from',
      render: (value) => dayjs(value).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: '结束时间',
      dataIndex: 'to',
      render: (value) => dayjs(value).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: '时段状态',
      render: (_, row) => (
        <Tag color={row.taken ? 'blue' : row.enabled ? 'green' : undefined}>
          {row.taken ? '已占用' : row.enabled ? '可预约' : '未开放'}
        </Tag>
      ),
    },
  ]
  return (
    <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
      <Typography.Text type="secondary">
        老师上传的未来单次时段。实际学生预约、期望申请及确认结果请在「预约跟进」中查看。
      </Typography.Text>
      <div>
        <Button onClick={retry} loading={loading}>
          刷新时段
        </Button>
      </div>
      {error ? (
        <Alert
          type="error"
          message="时段加载失败"
          action={<Button onClick={retry}>重试</Button>}
        />
      ) : (
        <Table
          rowKey="id"
          loading={loading}
          columns={columns}
          dataSource={data?.content ?? []}
          pagination={{
            current: pagination.page,
            pageSize: pagination.size,
            total: data?.total ?? 0,
            showSizeChanger: true,
            onChange: (page, size) =>
              setPagination((current) => ({
                page: size === current.size ? page : 1,
                size,
              })),
          }}
        />
      )}
    </Space>
  )
}
